import { WS_CONFIG, getRequestId } from '@/utils/wsConfig'
import { Message, MessageBox } from 'element-ui'
import {} from '@/utils/wsConfig'

class WebSocketService {
  constructor(url, options = {}) {
    this.url = url
    this.socket = null
    this.heartbeatInterval = null
    this.reconnectTimeout = null
    this.reconnectAttempts = 0
    this.messageQueue = {} // 消息队列

    this.options = {
      heartbeatMessage: {
        msgType: 8,
        body: {
          subType: 2,
          content: {}
        }
      },
      autoReconnect: true,
      ...options
    }

    this.init()
  }

  // 建立WebSocket连接
  init() {
    if ('WebSocket' in window) {
      this.socket = new WebSocket(this.url)
    } else {
      this.socket = null
      Message.warning('您的浏览器不支持WebSocket协议,建议使用新版谷歌浏览器！')
      return
    }
    this.bindEvents()
  }

  // WebSocket绑定
  bindEvents() {
    this.socket.onopen = this.onOpen.bind(this)
    this.socket.onmessage = this.onMessage.bind(this)
    this.socket.onclose = this.onClose.bind(this)
    this.socket.onerror = this.onError.bind(this)
  }

  // WebSocket解绑
  unbindEvents() {
    this.socket.onopen = null
    this.socket.onmessage = null
    this.socket.onclose = null
    this.socket.onerror = null
  }

  // WebSocket连接成功
  onOpen() {
    console.log('++++', 'WebSocket连接成功')
    this.reconnectAttempts = 0
    this.startHeartbeat()
    if (this.options.onOpen) this.options.onOpen()
  }

  // 处理消息接收
  onMessage(event) {
    try {
      if (!event.data) return
      const res = JSON.parse(event.data)
      if (this.options.onMessage) this.options.onMessage(res)
    } catch (err) {
      console.error('++++ WebSocket处理消息失败:', err.message)
    }
  }

  // WebSocket关闭
  onClose(event) {
    console.log('++++ WebSocket关闭:', event)
    if(this.options.onClose) this.options.onClose(event)
    if (event.code !== 1000) {
      this.reconnect()
    } else {
      this.stopHeartbeat()
    }
  }

  // WebSocket发生错误
  onError(event) {
    console.error('++++ WebSocket发生错误:', event)
    if(this.options.onClose) this.options.onClose(event)
    if (event.code === 1006) {
      this.reconnect()
    } else if (this.options.onError) {
      this.options.onError(event)
    }
  }

  // 启动心跳检测
  startHeartbeat() {
    this.heartbeatInterval = setInterval(() => {
      if (this.socket.readyState === WebSocket.OPEN) {
        const { heartbeatMessage } = this.options
        heartbeatMessage['requestId'] = getRequestId()
        this.socket.send(JSON.stringify(heartbeatMessage))
      }
    }, WS_CONFIG.HEARTBEAT_INTERVAL)
  }

  // 停止心跳检测
  stopHeartbeat() {
    clearInterval(this.heartbeatInterval)
  }

  // WebSocket重连
  reconnect() {
    if (this.options.autoReconnect && this.reconnectAttempts < WS_CONFIG.MAX_RECONNECT_ATTEMPTS) {
      this.stopHeartbeat()
      this.clearTaskQueue()

      let reconnectDelay = WS_CONFIG.RECONNECT_INTERVAL
      if (this.reconnectAttempts === 3) {
        reconnectDelay = 6000
      } else if (this.reconnectAttempts === 4) {
        reconnectDelay = 12000
      }
      this.reconnectAttempts++ // 重连尝试次数增加
      console.log('++++', `尝试重新连接... 重连间隔: ${reconnectDelay}ms`)

      this.reconnectTimeout = setTimeout(() => {
        this.init()
      }, reconnectDelay)
    } else {
      console.warn('++++', '重连尝试次数已达上限')
      MessageBox.confirm('会话连接失败，请尝试刷新页面重新连接！', '提示', {
        showClose: false,
        closeOnClickModal: false,
        confirmButtonText: '刷新',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          location.reload()
        })
        .catch(() => {})
    }
  }

  // 关闭WebSocket
  close() {
    this.stopHeartbeat()
    this.clearTaskQueue()
    clearTimeout(this.reconnectTimeout)
    this.unbindEvents()
    this.socket.close(1000)
    this.socket = null
  }

  // 清空消息任务队列
  clearTaskQueue() {
    Object.values(this.messageQueue).forEach(({ reject }) => {
      reject && reject()
    })
    this.messageQueue = {}
  }

  // 超出重连限制,一分钟后重连
  exceedLimit() {
    console.warn('++++', '重连尝试次数已达上限，立即尝试重连')
    setTimeout(() => {
      this.reconnectAttempts = 0 // 重置重连尝试次数
      this.init() // 尝试重新连接
    }, WS_CONFIG.MESSAGE_TIMEOUT)
  }
}

export default WebSocketService
// import store from '@/store'
// import { Message, Loading } from 'element-ui'
// import api from '@/api/pop'
// import { resCode } from '@/utils/res-types'

// // websocket实例
// let _ws = null
// // 客户端消息流水号
// let _clientMsgNo = 0
// // 消息队列
// let _wsMsgQueue = {}
// // 心跳定时器
// let _hbTimer = null
// // 重连定时器
// let _connectTimer = null
// let _loading = null

// function handleLoading() {
//   _loading = Loading.service({
//     spinner: 'el-icon-loading',
//     text: '消息连接中'
//   })
// }

// function closeLoading() {
//   _loading && _loading.close()
// }

// /**
//  * 清空消息任务队列
//  */
// function clearTaskQueue() {
//   Object.values(_wsMsgQueue).forEach(({ reject }) => {
//     reject && reject()
//   })
//   _wsMsgQueue = {}
// }

// // 通过时间戳和自增流水号生成
// function getClientMsgId() {
//   _clientMsgNo++
//   return Date.now().toString() + _clientMsgNo.toString()
// }

// function startHeatBeat() {
//   _hbTimer = setInterval(() => {
//     if (_ws) {
//       _ws.send(
//         JSON.stringify({
//           group: 'heartBeat',
//           data: 'ping'
//         })
//       )
//     }
//   }, 2000)
// }

// export async function loopMsgByWs({ dispatch }, getHistory) {
//   try {
//     handleLoading()
//     const res = await api.getToken()
//     if (res.code == resCode.success) {
//       _ws = new WebSocket(
//         `${process.env.VUE_APP_baseURL_POP_websocket}im-msg?id=${store.state.chat.chatInfo.userId}&flag=C&businessPartCode=${process.env.VUE_APP_baseURL_POP_businessPartCode}&token=${res.data}&merchantCode=${store.state.chat.chatInfo.merchantCode}`
//       )
//       _ws.onopen = () => {
//         console.log('ws open')
//         // window._ws = _ws;
//         // 需要同步历史消息
//         if (getHistory) {
//           dispatch('getCurrentMsg')
//         }
//         startHeatBeat()
//         closeLoading()
//       }
//       _ws.onmessage = ev => {
//         const res = JSON.parse(ev.data)
//         // 消息响应事件
//         if (res.type) {
//           const msgType = Number(res.type)

//           // 需响应消息返回ack
//           if (res.msgId) {
//             _ws.send(
//               JSON.stringify({
//                 group: 'ack',
//                 data: { msgId: res.msgId }
//               })
//             )
//           }

//           if (msgType == 703) {
//             // 消息发送失败
//             Message.warning(res.msg)
//             clearTaskQueue()
//             return
//           }

//           // 消费待处理消息
//           const task = _wsMsgQueue[res.clientMsgId]
//           if (task) {
//             task.resolve(res)
//             // 删除已处理任务
//             delete _wsMsgQueue[res.clientMsgId]
//           } else {
//             // 其他消息
//             dispatch('formatReceiveMsg', res)
//           }
//         }
//       }
//       _ws.onclose = ev => {
//         console.log(ev)
//         if (ev.code !== 1000) {
//           // 非正常关闭
//           dispatch('reconnnectWs')
//         }
//       }
//       _ws.onerror = ev => {
//         console.error(ev)
//         dispatch('reconnnectWs')
//       }
//     }
//   } catch (error) {
//     console.error(error)
//     dispatch('reconnnectWs')
//   }
// }

// export function startLoopMsgByWs({ dispatch }, getHistory) {
//   !_ws && dispatch('loopMsgByWs', getHistory)
// }

// export function stopLoopMsgByWs() {
//   if (_ws) {
//     clearTimeout(_hbTimer)
//     _ws.close()
//     _ws = null
//   }
// }

// export async function sendMsgByWs({ state, commit, dispatch }, content) {
//   try {
//     // 发送成功后显示后端返回的消息
//     const res = await new Promise((resolve, reject) => {
//       // 消息响应添加到队列
//       const clientMsgId = getClientMsgId()
//       _wsMsgQueue[clientMsgId] = {
//         clientMsgId,
//         resolve,
//         reject
//       }
//       _ws.send(
//         JSON.stringify({
//           group: 'customerSend',
//           data: content,
//           clientMsgId,
//           params: { dialogId: state.chatInfo.sessionId }
//         })
//       )
//     })
//     dispatch('formatReceiveMsg', res)
//   } catch (error) {
//     commit('setIsSending', false)
//     console.log(error)
//     return false
//   }
//   commit('setIsSending', false)
//   return true
// }

// export function reconnnectWs({ dispatch }) {
//   handleLoading()
//   clearTimeout(_connectTimer)
//   // 重连
//   clearTaskQueue()
//   _connectTimer = setTimeout(() => {
//     dispatch('stopLoopMsgByWs')
//     dispatch('startLoopMsgByWs', true)
//   }, 5000)
// }
